import { useTranslation } from 'react-i18next';
import { Construction } from 'lucide-react';

interface ComingSoonPlaceholderProps {
	/** i18n key for the page/section name shown above the message. */
	titleKey?: string;
}

/**
 * Destination for every menu route not yet migrated to admin-v2. Centered, neutral,
 * theme-aware. The real page replaces this route as each surface is migrated.
 */
export function ComingSoonPlaceholder({ titleKey }: ComingSoonPlaceholderProps) {
	const { t } = useTranslation();
	return (
		<div className="flex h-full min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
			<Construction className="text-foreground-disabled" size={40} strokeWidth={1.5} />
			{titleKey && <h2 className="text-lg font-semibold text-foreground">{t(titleKey)}</h2>}
			<p className="max-w-sm text-sm text-foreground-subtle">{t('shell.comingSoon')}</p>
		</div>
	);
}
